<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a><span class="bold">GCHQ</span></h1>
<p class="title1"><span class="bold">THE SECRET WIRELESS WAR 1900–86</span></p>
<p class="author">Nigel West</p>
<div class="pub"><img alt="image" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?6db2448b